class HpSaleHero extends HTMLElement {
  connectedCallback() {
    const btn = this.querySelector('.hp-sale-hero__code-btn');
    if (!btn) return;
    btn.addEventListener('click', () => this.copyCode(btn));
  }

  copyCode(btn) {
    const code = btn.dataset.code;
    if (!code || !navigator.clipboard) return;

    const originalLabel = btn.getAttribute('aria-label');

    navigator.clipboard.writeText(code).then(() => {
      btn.classList.add('hp-sale-hero__code-btn--copied');
      btn.setAttribute('aria-label', 'Copied!');

      setTimeout(() => {
        btn.classList.remove('hp-sale-hero__code-btn--copied');
        btn.setAttribute('aria-label', originalLabel);
      }, 2000);
    });
  }
}

customElements.define('hp-sale-hero', HpSaleHero);
